import Control from "../../1. Core/Control";
import Label from "../../1. Core/Controls/Label/Label";
import {Slice} from "./TechReport";
import {loadFiles} from "../../1. Core/ScriptLoader";


export default class JudgePointsTable extends Control {
	private _Instance: any;
	private _gridOptions: any;
	private _lbl: Label;
	private _noDataLabel: Label;


	_initFields(settings: object)
	{
		super._initFields(settings);
	}

	constructor(settings?: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="tech-table ag-theme-balham"></div>');

		this._lbl = new Label({
			ParentNode: this._root,
			RK: 'Judge points'
		});

		this._br();

		this._noDataLabel = new Label({
			ParentNode: this._root,
			RK: 'NoData'
		});

		this._noDataLabel.setIsVisible(false);

		if (this._ParentNode)
			this.putToNode(this._ParentNode);
	}

	refresh(data: Slice)
	{
		if (this._Instance)
			this._Instance.destroy();

		if (!(<any>window).AgGrid)
			return loadFiles(['ag-grid.js', 'ag-grid.css']).then(() => this.isLive() && this.refresh(data));

		let columnDefs: any[] = [];

		//let data = techData.JudgePoints;

		if (!data || !data.Data || data.Data.length == 0)
		{
			this._noDataLabel.setIsVisible(true);
			return
		}
		else
			this._noDataLabel.setIsVisible(false);

		// columnDefs.push({
		// 	headerName: NP.RM.getString("Round")
		// }, ...data.TopSlots.map(name => ({headerName: name})));
		columnDefs.push( ...data.TopSlots.map(name => ({headerName: name})));

		this.setColField(columnDefs, 0);

		let rowData = [];

		for (let i = 0; i < data.Data.length; i++)
		{
			if (!data.Data[i])
				break;
			// let res: any = i == data.Data.length - 1 ? {0: NP.RM.getString('Total')} : {0: i + 1};
			// data.Data[i].forEach((cell: number, index: number) => res[index + 1] = cell);
			let res: any = [];
			data.Data[i].forEach((cell: number, index: number) => res[index] = cell);
			rowData.push(res);
		}

		this._Instance = new (window as any).AgGrid(this._root, this._gridOptions = {
			columnDefs: columnDefs,
			rowData: rowData,
			"headerHeight": 40,
			domLayout: 'autoHeight',
			"enableSorting": false,
			"animateRows": true,
			"enableColResize": false,
			"suppressPropertyNamesCheck": true,
			"suppressRowClickSelection": true,
			"suppressColumnVirtualisation": true,
			getRowStyle: function (params: any)
			{
				if (params.node.rowIndex % 2 == 0)
				{
					return {background: 'rgba(0, 0, 0, 0.12)'}
				}
			},
			onFirstDataRendered: (() =>
			{
				if (this._gridOptions)
				{
					let allColumnIds = this._gridOptions.columnApi.getAllColumns().map((column: any) => column.colId);
					this._gridOptions.columnApi.autoSizeColumns(allColumnIds);
					this._root.style.width = (this._root.querySelector(".ag-header-container") as HTMLElement).offsetWidth + 2 + 'px';
				}
			})
		});
	}

	_cellGeneralStyleFunc(cell: any)
	{
		let style: any = {};

		style.textAlign = 'center';
		if (!isNaN(cell.value) && cell.value < 0)
			style.color = '#E74342';

		return style;
	}


	setColField(columnDefs: any[], index: number)
	{
		for (let col of columnDefs)
		{
			if (col.children)
			{
				index = this.setColField(col.children, index);
			}
			else
			{
				col.field = "" + index++;
			}
			col.cellStyle = this._cellGeneralStyleFunc;
		}
		return index;
	}

	clear()
	{
		if (this._Instance)
		{
			this._Instance.destroy();
			this._Instance = null;
		}
	}
}